import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from 'react-tooltip';
import { TooltipWrapper } from './style';
import { Text } from '../../atoms';
import { withMediaQueries } from '../../../app/hoc/withMediaQueries';

const Tooltips = ({ mediaIsPhone }) => {
  return (
    <>
      <TooltipWrapper>
        <Tooltip
          id="my-tooltip"
          opacity={1}
          place={mediaIsPhone ? 'top' : 'right'}
          render={({ content, activeAnchor }) => (
            <span>
              {activeAnchor?.getAttribute('data-title') && (
                <Text type="h3" mb={8}>
                  {activeAnchor?.getAttribute('data-title') || ''}
                </Text>
              )}
              {activeAnchor?.getAttribute('data-text') && (
                <Text type="b3">
                  {activeAnchor?.getAttribute('data-text') || ''}
                </Text>
              )}
            </span>
          )}
        />
      </TooltipWrapper>
      <TooltipWrapper className="secondary">
        <Tooltip
          id="my-tooltip-secondary"
          opacity={1}
          place={mediaIsPhone ? 'top' : 'right'}
          render={({ content, activeAnchor }) => (
            <span>
              {activeAnchor?.getAttribute('data-title') && (
                <Text type="h3" mb={8}>
                  {activeAnchor?.getAttribute('data-title') || ''}
                </Text>
              )}
              {activeAnchor?.getAttribute('data-text') && (
                <Text type="b3">
                  {activeAnchor?.getAttribute('data-text') || ''}
                </Text>
              )}
            </span>
          )}
        />
      </TooltipWrapper>
    </>
  );
};

Tooltips.propTypes = {
  mediaIsPhone: PropTypes.bool,
};

export default withMediaQueries(Tooltips);
